import { Component, OnDestroy, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ProgressBarMode } from '@angular/material/progress-bar';
import {
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
} from '@angular/router';
import { LoaderService } from './services/loader.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'divine-infinite-being-angular-ui';
  color: ThemePalette = 'accent';
  mode: ProgressBarMode = 'indeterminate';
  public loader: boolean = false;

  private loaderSubscription!: Subscription;
  private routerSubscription!: Subscription;

  constructor(public router: Router, private loaderService: LoaderService) {}

  ngOnInit() {
    this.loaderSubscription = this.loaderService.isLoading$.subscribe(
      (isLoading) => {
        setTimeout(() => {
          this.loader = isLoading;
        }, 0);
      }
    );

    this.routerSubscription = this.router.events.subscribe((event) => {
      switch (true) {
        case event instanceof NavigationStart:
          this.loaderService.show();
          break;
        case event instanceof NavigationEnd:
        case event instanceof NavigationError:
          this.loaderService.hide();
          break;
      }
    });
  }

  ngOnDestroy() {
    if (this.loaderSubscription) {
      this.loaderSubscription.unsubscribe();
    }
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
